import { Button, Col, Row } from 'antd'
import React from 'react'
import styled from 'styled-components'
import { CheckOutlined } from '@ant-design/icons'
import { useLocation, useNavigate } from 'react-router-dom'

function Success() {
  const navigate = useNavigate()
  const location = useLocation()
  const {data} = location.state || {}

  return (
    <SuccessWrapper>
      <Row>
        <Col xs={24}>
          <Main>
            <IconWrapper>
              <CheckOutlined />
            </IconWrapper>

            <TitleWrapper>
              <h1>Nộp hồ sơ thành công!</h1>
              <p>Hồ sơ của bạn đã được gửi tới hệ thống và đang chờ thẩm định.</p>
            </TitleWrapper>

            <Container>
              <InfoRow>
                <TitleRow>Mã hồ sơ:</TitleRow>
                <Info>{data?.success_submission_id}</Info>
              </InfoRow>

              <DividerCustome />

              <InfoRow>
                <TitleRow>Thời gian nộp:</TitleRow>
                <Info>{new Date().toLocaleString()}</Info>
              </InfoRow>

              <DividerCustome />

              <InfoRow>
                <TitleRow>Trạng thái:</TitleRow>
                <Info isStatus>Chờ xác nhận</Info>
              </InfoRow>
            </Container>

            <BtnWrapper>
              <Button className="btnHome" onClick={() => navigate('/')}>
                Về trang chủ
              </Button>
            </BtnWrapper>
          </Main>
        </Col>
      </Row>
    </SuccessWrapper>
  )
}

export default Success

const SuccessWrapper = styled.div`
  min-height: 100vh;
  background: #f9fafb;
`

const Main = styled.div`
  margin-top: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 739px) {
    margin-top: 40px;
    padding: 0 12px;
  }
`

const IconWrapper = styled.div`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: #e3f3ef;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    font-size: 52px;
    color: #16a34a;
  }

  @media (max-width: 739px) {
    width: 80px;
    height: 80px;

    svg {
      font-size: 40px;
    }
  }
`

const TitleWrapper = styled.div`
  margin-top: 24px;
  text-align: center;

  h1 {
    font-size: 32px;
    font-weight: 700;
    color: #101828;
    margin: 0;
  }

  p {
    margin-top: 8px;
    font-size: 16px;
    color: #475467;
  }

  @media (max-width: 739px) {
    h1 {
      font-size: 22px;
    }

    p {
      font-size: 14px;
    }
  }
`

const Container = styled.div`
  width: 500px;
  margin-top: 20px;
  padding: 30px;
  border: 1px solid #e5e7eb;
  border-radius: 15px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  @media (max-width: 739px) {
    width: 100%;
    padding: 20px;
  }
`

const InfoRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 739px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
`

const TitleRow = styled.p`
  font-weight: 500;
  font-size: 17px;
  margin: 0;

  @media (max-width: 739px) {
    font-size: 14px;
  }
`

const Info = styled.p`
  font-weight: 700;
  font-size: 17px;
  margin: 0;
  color: ${({ isStatus }) => (isStatus ? '#d97705' : '#333')};

  @media (max-width: 739px) {
    font-size: 15px;
  }
`

const DividerCustome = styled.div`
  width: 100%;
  height: 1px;
  background: #e5e7eb;
  margin: 15px 0;
`

const BtnWrapper = styled.div`
  margin-top: 40px;
  width: 100%;
    justify-content: center;
    display: flex;
  .btnHome {
    width: 240px;
    height: 48px;
    background: #ec1c2a;
    color: #fff;
    font-size: 17px;
    border-radius: 8px;
    border: none;


    @media (max-width: 739px) {
      width: 100%;
      font-size: 16px;
    }
  }
`
